module.exports = __webpack_public_path__ + "static/vision_text-c87f6279a322ad51c02d46a8af8028d9.svg";